module.exports = __webpack_public_path__ + "static/img/guideBoxBg.bacf606.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cashWheel/guideBoxBg.webp
// module id = fUpV
// module chunks = 0